'use client'
import { phoneReg, emailReg } from '@/constants/regular';
import slider01 from '@/assets/images/about/intro01.png';
import servicePic01 from '@/assets/images/about/servicePic01.png';
import servicePic02 from '@/assets/images/about/servicePic02.png';
import servicePic03 from '@/assets/images/about/servicePic03.png';
import servicePic04 from '@/assets/images/about/servicePic04.png';
import ad01 from '@/assets/images/about/ad01.png';
import cooper01 from '@/assets/images/about/cooper01.png';
import cooper02 from '@/assets/images/about/cooper02.png';
import cooper03 from '@/assets/images/about/cooper03.png';
import logo01 from '@/assets/images/about/brand/logo01.png';
import logo02 from '@/assets/images/about/brand/logo02.png';
import logo03 from '@/assets/images/about/brand/logo03.png';
import logo04 from '@/assets/images/about/brand/logo04.png';
import logo05 from '@/assets/images/about/brand/logo05.png';
import logo06 from '@/assets/images/about/brand/logo06.png';
import logo07 from '@/assets/images/about/brand/logo07.png';
import logo08 from '@/assets/images/about/brand/logo08.png';
import logo09 from '@/assets/images/about/brand/logo09.png';
import logo10 from '@/assets/images/about/brand/logo10.png';


//import companyPic0 from '@/assets/images/about/companyZiZhi/companyPic (0).jpeg';
import companyPic01 from '@/assets/images/about/companyZiZhi/companyPic (1).png';
import companyPic02 from '@/assets/images/about/companyZiZhi/companyPic (2).png';
import companyPic03 from '@/assets/images/about/companyZiZhi/companyPic (3).png';
import companyPic04 from '@/assets/images/about/companyZiZhi/companyPic (4).png';
import companyPic05 from '@/assets/images/about/companyZiZhi/companyPic (5).png';
import companyPic06 from '@/assets/images/about/companyZiZhi/companyPic (6).png';
import companyPic07 from '@/assets/images/about/companyZiZhi/companyPic (7).png';

import certify01 from '@/assets/images/about/xinchuangCertificate/certificate (1).png';
import certify02 from '@/assets/images/about/xinchuangCertificate/certificate (2).png';
import certify03 from '@/assets/images/about/xinchuangCertificate/certificate (3).png';
import certify04 from '@/assets/images/about/xinchuangCertificate/certificate (4).png';
import certify05 from '@/assets/images/about/xinchuangCertificate/certificate (5).png';
import certify06 from '@/assets/images/about/xinchuangCertificate/certificate (6).png';
import certify07 from '@/assets/images/about/xinchuangCertificate/certificate (7).png';
import certify08 from '@/assets/images/about/xinchuangCertificate/certificate (8).png';
import certify09 from '@/assets/images/about/xinchuangCertificate/certificate (9).png';
import certify10 from '@/assets/images/about/xinchuangCertificate/certificate (10).png';
import certify11 from '@/assets/images/about/xinchuangCertificate/certificate (11).png';
import certify12 from '@/assets/images/about/xinchuangCertificate/certificate (12).png';
import certify13 from '@/assets/images/about/xinchuangCertificate/certificate (13).png';
import certify14 from '@/assets/images/about/xinchuangCertificate/certificate (14).png';
import certify15 from '@/assets/images/about/xinchuangCertificate/certificate (15).png';

export const logoList = [
    logo01.src,
    logo02.src,
    logo03.src,
    logo04.src,
    logo05.src,
    logo06.src,
    logo07.src,
    logo08.src,
    logo09.src,
    logo10.src,
]
export const introList = [{
    title: '公司简介',
    content: ['上海奇夜语网络科技有限公司于2020年3月成立于中国上海，隶属于360集团（股票代码：601360）。',
        '在国家“十四五规划”全面推进数字化、建设数字中国和网络强国的背景下，基于全面开放的平台架构和新一代的智能连接技术，通过智能消息推送和处理引擎，实现组织内各类办公和业务系统的快速整合，以及组织之间可管可控的互联互通，帮助政企用户有效整合信息化资源，打造统一的智能工作入口，全面构建起一个集消息中心、事务中心、应用中心和管理中心于一体的智能数字化协作中枢。',
        '在政企数字化转型的过程中，帮助用户形成“用数据对话、用数据决策、用数据服务、用数据创新”的数字化治理和管理模式，致力于提升国内政企工作效能，助力加速推进政企数字化转型进程。'],
    imgUrl: slider01.src
}, {
    title: '我们的产品',
    content: ['360织语作为全景化智能协同工作平台，以即时通讯及协同门户为核心，全面整合业务协作、办公协作、流程协作和信息协同，打通业务流和信息流，实现组织内各类办公和业务系统的快速整合，以及组织之间可管可控的互联互通，凭借“一个平台、五大连接、六个中心、五重保障、应用生态”的核心规划，帮助大型政企组织有效整合信息化资源，并针对复杂业务场景随需而变，驱动数字化创新，拥抱数字化转型挑战。',
        '在信创和数字化转型“齐头并进”的当下，360织语具备“极致连接、深度融合、闭环协作、安全可控”的产品优势，灵活扩展、随需而变，高效连接融合各类应用系统，打破信息孤岛，形成工作闭环，帮助用户激活已有信息化资产，提升组织资源配置能力，真正做到“赋能于用户”。',
        '360织语基于多维产品能力矩阵，并结合全面的协同产品能力、极致的开放融合能力和全方位的安全保障能力，形成了面向政府、金融、航空、军工、能源、制造、教育、医疗等多行业解决方案。',
        '360织语受邀参与中国信通院《办公即时通信软件安全标准》等多个标准的编制和推广，并成功入选信通院“铸基计划”标准贡献单位。基于360安全防御体系，360织语专设“全程防窃听、事前防泄漏、事中防扩散、事后可追溯”的安全机制，在业内首推高密低流管控、内外网穿透、明暗双重水印等安全保密功能，凭借着过硬的技术实力，向行业输送大量安全即时通讯与协同办公实践经验，助力行业水平快速提升。',
        '同时，360织语已经和国产主流软硬件进行全栈适配，具备专业涉密信创产品能力，支持多种信创环境组合运行，适配用户各类信创建设路线，全面领跑信创协同办公市场。'
    ]
}]

export const list01 = {
    title: "公司资质",
}
export const list02 = {
    title: "信创证书",
}
export const list03: any = {
    title: "荣誉证书",
    imgUrl: ad01.src,
    imgClass: 'mt30'
}

export const list04 = {
    title: "以用户为中心，全生命周期的服务体系",
    cont: ["专业团队，全流程项目管理框架"],
}
export const serviceList01: any = [{
    title: '全方位的顾问体系',
    content: ['专业需求咨询；前沿蓝图规划；行业经验输送；量身定制解决方案'],
    imgUrl: servicePic01.src,

}, {
    title: '4A级的交付体系',
    content: ["客制化交付方案；360原厂定制服务；专家级运营推广"],
    imgUrl: servicePic02.src,
    imgFirst: true
},


{
    title: '高标准质量管理体系',
    content: ["通过软件能力成熟度模型CMMI3级认证、ISO9001质量管理体系、ISO20000服务管理体系认证"],
    imgUrl: servicePic03.src,
},
{
    title: '一对一专属VIP客服体系',
    content: ['随时随地响应；问题极速处理；定期巡检服务；主动召回机制'],
    imgUrl: servicePic04.src,
    imgFirst: true

},]

export const cooperationList01 = {
    title: "“织”慧办公",
    titleAdd: '“语”您同行',
    cont: "携手共赢 创造未来 期待您的加入！",
}


export const cooperList02 = [{
    name: '渠道战略伙伴',
    cont: '携手360织语，共创行业解决方案，共同推进行业市场合作，助力政企数字化转型',
    imgUrl: cooper01.src
},
{
    name: '开发服务商',
    cont: '为织语用户提供部署实施、定制开发服务，满足政企个性化需求',
    imgUrl: cooper02.src
},
{
    name: 'ISV',
    cont: '携手360织语，融合共创全景化数字协作平台，提供丰富的软硬件产品及应用，让用户获得一站式的使用体验',
    imgUrl: cooper03.src
}
]

export const formFieldList = [
    {
        itemProps: {
            label: "公司名称",
            name: 'company_name',
            rules: [
                { required: true, message: '请输入公司名称' },
            ]
        },
        compProps: {
            placeholder: "请输入公司名称"
        }

    },
    {
        itemProps: {
            label: "申请人",
            name: 'applicant_name',
            rules: [
                { required: true, message: '请输入申请人姓名' },
            ]
        },
        compProps: {
            placeholder: "请输入申请人姓名"
        }

    },
    {
        itemProps: {
            label: "手机",
            name: 'phone',
            rules: [
                { required: true, message: '请输入您的手机号' },
                { pattern: phoneReg, message: '手机号格式不正确' }
            ]
        },
        compProps: {
            placeholder: '请输入您的手机号'
        }

    },

    {
        itemProps: {
            label: "邮箱",
            name: 'email',
            rules: [
                { required: true, message: '请输入您的邮箱地址' },
                { pattern: emailReg, message: '邮箱格式不正确', validateTrigger: 'onBlur' }
            ]
        },
        compProps: {
            placeholder: '请输入您的邮箱地址'
        }



    }
]


export const imgList01 = [
    companyPic01.src,
    companyPic02.src,
    companyPic03.src,
    companyPic04.src,
    companyPic05.src,
    companyPic06.src,
    companyPic07.src,
]
export const imgList02 = [
    certify01.src,
    certify02.src,
    certify03.src,
    certify04.src,
    certify05.src,
    certify06.src,
    certify07.src,
    certify08.src,
    certify09.src,
    certify10.src,
    certify11.src,
    certify12.src,
    certify13.src,
    certify14.src,
    certify15.src,
]


